<template>
  <div id="screensaver" class="vcenter-content">
    <marque class="vcenter" v-if="siteIntro"></marque>
    <transition name="longfade">
      <h3 class="h5 century-mono vcenter" v-if="!siteIntro" v-show="showTagline">
        Contemporary Products,<br>
        Traditional Craftsmanship,<br> 
        Designed and<br>
        Conceived in London
      </h3>
    </transition>
    <cinemagraph v-if="!siteIntro" :blur="true" :lowRes="sleepMode" :site="site" @playing="showTagline = true"></cinemagraph>
  </div>
</template>

<script>
import Marque from './LogoMarque'
import Cinemagraph from './VideoBackground'
export default {
  name: 'screensaver',
  props: ['sleepMode', 'siteIntro'],
  components: {
    Marque,
    Cinemagraph
  },
  data () {
    return {
      showTagline: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';
#screensaver{
  @include background(fixed);
  z-index:$z-screensaver;
  text-align: center;
  .logo-marque{
    width:8.9837890625vw;
    stroke:$white;
    mix-blend-mode:difference;
    stroke-width:3.6764705882%;
  }
  h3{
    position:relative;
    z-index:1;
    color:$white;
    padding:$gutter*2;
    mix-blend-mode:difference;
    line-height:1.65;
  }
  .video-background{
    z-index: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Screensaver.vue?57a4a8da